"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FuseConfirmDialogModule = /** @class */ (function () {
    function FuseConfirmDialogModule() {
    }
    return FuseConfirmDialogModule;
}());
exports.FuseConfirmDialogModule = FuseConfirmDialogModule;
